<!-- Indicator of total number of persistent alerts -->
<div class="banner">
  Persistent Alerts: {{ socketService.perAlerts.length || 0 }}
</div>
@if (socketService.perAlerts.length > 0) {
<div class="persistent-popup">
  <!-- Card for each alert -->
  @for (alert of socketService.perAlerts; track alert) {
  <app-persistent-alert-card
    (closeClick)="closedCard()"
    [selectedAlert]="alert"
  ></app-persistent-alert-card>
  }
</div>
} @else {
<!-- Empty state -->
<div class="empty-state">
  <li>All Alerts Acknowledged.</li>
  <button mat-flat-button color="primary" (click)="close()">Close</button>
</div>
}
